module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap"
  }, [_c('b', [_vm._v("Standard Quilt Sizes")])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c-1"
    }
  }, [_c('i', [_vm._v("Bed, Comforter, Coverlet, and Bedspread Measurements")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('i', [_vm._v("Comforters cover the mattress but not the box spring and generally don’t have a pillow tuck. Coverlets cover the mattress and box spring and generally have a pillow tuck. Bedspreads cover the bed to almost the floor and have a pillow tuck.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c-2"
    }
  }, [_c('i', [_vm._v("Quilt Sizes with Drop and Tuck")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/5a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('i', [_vm._v("Drop hangs over the edge of the mattress on 3 sides. Tuck folds under the pillow.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc1b7f14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter1.vue
// module id = 63
// module chunks = 0